import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import parser from 'html-react-parser'

export default function DonorsList({data}) {
    const {donorsListTitle, donorsListFirstImage, donorsListFirstList, donorsListSecondImage, donorsListSecondList, donorsListThirdList} = data
    return (
        <div className='donors-list-wrap panel-space-70'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12'>
                        <h2 className='heading-level-2 blue-color text-center'>
                            {donorsListTitle && parser(donorsListTitle)}
                        </h2>
                    </div>
                </div>

                <div className='row donor-list-row'>
                    {donorsListFirstList?.map((block, index) => {
                        return (
                            <div className='col-md-3 col-6' key={index}>
                                {block.donorsListFirstListName &&
                                    parser(block.donorsListFirstListName)}
                            </div>
                        );
                    })}
                </div>

                <div className='row'>
                    <div className='col-md-12'>
                        <figure className='donor-image-fullwidth'>
                            <GatsbyImage
                                image={getImage(donorsListFirstImage?.localFile)}
                                alt='image'
                            />
                        </figure>
                    </div>
                </div>
                <div className='row donor-list-row'>
                    {donorsListSecondList?.map((block, index) => {
                        return (
                            <div className='col-md-3 col-6' key={index}>
                                {block.donorsListSecondListName &&
                                    parser(block.donorsListSecondListName)}
                            </div>
                        );
                    })}
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <figure className='donor-image-fullwidth'>
                            <GatsbyImage
                                image={getImage(donorsListSecondImage?.localFile)}
                                alt='image'
                            />
                        </figure>
                    </div>
                </div>
                <div className='row donor-list-row'>
                    {donorsListThirdList?.map((block, index) => {
                        return (
                            <div className='col-md-3 col-6' key={index}>
                                {block.donorsListThirdListName &&
                                    parser(block.donorsListThirdListName)}
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    )
}
